













































const userModule = namespace('user');

import blankDataFieldsPostCall from '@/components/exception-reports/blank-data-fields-post-call.vue';
import callbacksOverdue from '@/components/exception-reports/callbacks-overdue.vue';
import cancellationReasons from '@/components/exception-reports/cancellation-reasons.vue';
import clientsConsideringOptions from '@/components/exception-reports/clients-considering-options.vue';
import instructedClearedVariances from '@/components/exception-reports/instructed-cleared-variances.vue';
import monitorAppointmentBookings from '@/components/exception-reports/monitor-appointment-bookings.vue';
import noLongerProceedingClients from '@/components/exception-reports/no-longer-proceeding-clients.vue';
import nonInstructionReasons from '@/components/exception-reports/non-instruction-reasons.vue';
import outstandingAppointmentOutcomes from '@/components/exception-reports/outstanding-appointment-outcomes.vue';
import outstandingPayments from '@/components/exception-reports/outstanding-payments.vue';
import outstandingSignings from '@/components/exception-reports/outstanding-signings.vue';
import tasksOverdue from '@/components/exception-reports/tasks-overdue.vue';
import tasksUnassigned from '@/components/exception-reports/tasks-unassigned.vue';
import userReport from '@/components/exception-reports/user-report.vue';
import layout from '@/layouts/app.vue';
import { User } from '@/shared/user';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

@Component({
    components: {
        layout,
        blankDataFieldsPostCall,
        callbacksOverdue,
        cancellationReasons,
        clientsConsideringOptions,
        instructedClearedVariances,
        monitorAppointmentBookings,
        noLongerProceedingClients,
        nonInstructionReasons,
        outstandingAppointmentOutcomes,
        outstandingPayments,
        outstandingSignings,
        tasksOverdue,
        tasksUnassigned,
        userReport,
    },
})

export default class ExceptionReports extends Vue {
    @userModule.Getter('user') private currentUser!: User;

    private selectedReportItem: number | null = null;

    private get reportItems(): Array<{}> {
        const appointments: Array<{}> = [];
        const usage: Array<{}> = [];
        const tasks: Array<{}> = [];
        const customerExperienceTeam: Array<{}> = [];

        this.addItem(appointments, { value: 0, text: 'Clients Considering Options', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'PP Key Stakeholder'] });
        this.addItem(appointments, { value: 1, text: 'Outstanding Signings', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'PP Key Stakeholder'] });
        this.addItem(appointments, { value: 2, text: 'Outstanding Payments', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'PP Key Stakeholder'] });
        this.addItem(appointments, { value: 3, text: 'Non-Instruction Reasons', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'PP Key Stakeholder'] });
        this.addItem(appointments, { value: 4, text: 'No Longer Proceeding/Write-Off Clients', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'PP Key Stakeholder'] });
        this.addItem(appointments, { value: 5, text: 'Instructed - Cleared Variances', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'PP Key Stakeholder'] });
        this.addItem(appointments, { value: 6, text: 'Cancellation Reasons', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'PP Key Stakeholder', 'Customer experience executive team leader', 'Head of Customer Experience Team'] });

        this.addItem(usage, { value: 7, text: 'Outstanding Appointment Outcomes', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'PP Key Stakeholder'] });
        this.addItem(usage, { value: 8, text: 'Blank Data Fields Post Calls', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'Customer experience executive team leader', 'Head of Customer Experience Team'] });
        this.addItem(usage, { value: 9, text: 'User Report', roles: ['System', 'Administrator', 'Internal Key Stakeholder'] });

        this.addItem(tasks, { value: 10, text: 'Tasks Overdue', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'Customer experience executive team leader', 'Head of Customer Experience Team', 'Data creation team leader'] });
        this.addItem(tasks, { value: 11, text: 'Tasks Unassigned', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'Customer experience executive team leader', 'Head of Customer Experience Team', 'Data creation team leader'] });

        this.addItem(customerExperienceTeam, { value: 12, text: 'Callbacks Overdue', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'Customer experience executive team leader', 'Head of Customer Experience Team'] });
        this.addItem(customerExperienceTeam, { value: 13, text: 'Monitor Appointment Bookings', roles: ['System', 'Administrator', 'Internal Key Stakeholder', 'Customer experience executive team leader', 'Head of Customer Experience Team'] });

        const options: Array<{}> = [{ value: null, text: '--- Please Select ---' }];

        if (appointments.length) {
            options.push({ label: 'Appointments', options: appointments });
        }

        if (usage.length) {
            options.push({ label: 'Usage', options: usage });
        }

        if (tasks.length) {
            options.push({ label: 'Tasks', options: tasks });
        }

        if (customerExperienceTeam.length) {
            options.push({ label: 'Customer Experience Team', options: customerExperienceTeam });
        }

        return options;
    }

    private addItem(collection: Array<{}>, item: { value: number | null, text: string, roles: Array<string> }): void {
        const userRoles = this.currentUser.roles.map((role) => role.name.toLowerCase());
        const itemRoles = item.roles.map((role) => role.toLowerCase());

        if (userRoles.some((role) => itemRoles.indexOf(role) > -1)) {
            collection.push(item);
        }

    }
}
